export type AgentWidgetMode = 'chat' | 'code' | 'search' | 'image' | 'video' | 'speech'

const VALID_WIDGET_MODES: AgentWidgetMode[] = ['chat', 'code', 'search', 'image', 'video', 'speech']
const FULLSCREEN_WIDGET_MODES: AgentWidgetMode[] = ['speech', 'search', 'image', 'video']
const LEGACY_MODE_ALIASES: Record<string, AgentWidgetMode> = {
  voice: 'speech',
}

const resolveWidgetMode = (value: unknown): AgentWidgetMode | null => {
  if (typeof value !== 'string') return null
  const normalized = value.toLowerCase().trim()

  if ((VALID_WIDGET_MODES as string[]).includes(normalized)) {
    return normalized as AgentWidgetMode
  }

  return LEGACY_MODE_ALIASES[normalized] ?? null
}

export const isAgentWidgetMode = (value: unknown): value is AgentWidgetMode =>
  resolveWidgetMode(value) !== null

export const normalizeAgentWidgetMode = (
  value: unknown,
  fallback: AgentWidgetMode = 'chat'
): AgentWidgetMode => {
  return resolveWidgetMode(value) ?? fallback
}

export const isFullscreenWidgetMode = (value: unknown): value is AgentWidgetMode => {
  const mode = resolveWidgetMode(value)
  if (!mode) return false
  return FULLSCREEN_WIDGET_MODES.includes(mode)
}
